/**
 * Authentication Routes Configuration
 * Routes for login, register, password reset, etc.
 */
import { lazy } from 'react';
import { AUTH_ROUTES } from './constants';

// Lazy load components
const LoginPage = lazy(() => import('@/pages/auth/LoginPage'));
const RegisterPage = lazy(() => import('@/pages/auth/RegisterPage'));
const ForgotPasswordPage = lazy(() => import('@/pages/auth/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('@/pages/auth/ResetPasswordPage'));
const GoogleCallback = lazy(() => import('@/pages/auth/GoogleCallback'));

/**
 * Authentication route configuration array
 */
export const authRoutes = [
  {
    path: AUTH_ROUTES.LOGIN,
    component: LoginPage,
    name: 'Login',
    meta: {
      title: 'Login - VastuSindu',
      description: 'Sign in to your account',
      requiresGuest: true, // Redirect to dashboard if already authenticated
    },
  },
  {
    path: AUTH_ROUTES.REGISTER,
    component: RegisterPage,
    name: 'Register',
    meta: {
      title: 'Register - VastuSindu',
      description: 'Create a new account',
      requiresGuest: true,
    },
  },
  {
    path: AUTH_ROUTES.FORGOT_PASSWORD,
    component: ForgotPasswordPage,
    name: 'Forgot Password',
    meta: {
      title: 'Forgot Password - VastuSindu',
      description: 'Reset your password',
      requiresGuest: true,
    },
  },
  {
    path: AUTH_ROUTES.RESET_PASSWORD,
    component: ResetPasswordPage,
    name: 'Reset Password',
    meta: {
      title: 'Reset Password - VastuSindu',
      description: 'Set a new password',
      requiresGuest: true,
    },
  },
  {
    path: AUTH_ROUTES.GOOGLE_CALLBACK,
    component: GoogleCallback,
    name: 'Google Callback',
    meta: {
      title: 'Authenticating...',
      description: 'Processing Google authentication',
    },
  },
];

export default authRoutes;
